export default "__VITE_ASSET__eb8ad703__"